import { CustomerGroupService } from './customer-group/customer-group.service';
import { PermissionService } from './permission/permission.service';
import { EventService } from './event/event.service';
import { DestinationTypeService } from './destination-type/destination-type.service';
import { ProcessTransitionService } from './process-transition/process-transition.service';
import { CollectionService } from './collection/collection.service';
import { ConditionService } from './condition/condition.service';
import { StyleService } from './style/style.service';
import { SizeService } from './size/size.service';
import { CategoryService } from './category/category.service';
import { CustomerService } from './customer/customer.service';
import { OrderService } from './order/order.service';
import { ProductService } from './product/product.service';
import { DestinationService } from './destination/destination.service';
import { InventoryService } from './inventory/inventory.service';
import { LocationService } from './location/location.service';
import { Injectable } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { UserService } from './user/user.service';
import { DesignerService } from './designer/designer.service';
import { StatusService } from './status/status.service';
import { ProcessTypesService } from './process-types/process-types.service';
import { ProcessStatusService } from './process-status/process-status.service';
import { CustomerAddressService } from './customer-address/customer-address.service';
import { TrackService } from './track/track.service';
import { RoleService } from './role/role.service';
import { ConstantService } from './constant/constant.service';
import { ProviderService } from './provider/provider.service';
import { AnalyticService } from './analytic.service';
import { CurrencyService } from './currency/currency.service';
import { CourierService } from './courier/courier.service';
import { ColorService } from './color/color.service';
import { WardrobeService } from './wardrobe/wardrobe.service';
import { WishlistService } from './wishlist/wishlist.service';
import { OffersService } from './offers/offers.service';
import { GeneralService } from './general/general.service';
import { DeliveryService } from './delivery/delivery.service';
import { PaymentService } from './payment/payment.service';
import { AsyncProcessService } from './async-process/async-process.service';
import {CheckoutService} from "./checkout/checkout.service";
import { CouponService } from './coupon/coupon.service';
import { CartruleService } from './cartrule/cartrule.service';
import {ElasticsearchService} from "./elasticsearch/elasticsearch.service";
import { ProcessStatusGroupService } from './process-status-group/process-status-group.service';
import { CustomAttributeService } from './custom-attribute/custom-attribute.service';import { CustomAttributeOptionService } from './custom-attribute-option/custom-attribute-option.service';
import { FileService } from './file/file.service';
import { OrderProductService } from './order-product/order-product.service';
@Injectable()
export class ApiService {
  constructor(
    public customAttributeOption: CustomAttributeOptionService,
    public customAttribute: CustomAttributeService,
    public processStatusGroup: ProcessStatusGroupService,
    public cartrule: CartruleService,
    public coupon: CouponService,
    public wardrobe: WardrobeService,
    public color: ColorService,
    public location: LocationService,
    public inventory: InventoryService,
    public destination: DestinationService,
    public auth: AuthService,
    public product: ProductService,
    public order: OrderService,
    public user: UserService,
    public customer: CustomerService,
    public category: CategoryService,
    public size: SizeService,
    public designer: DesignerService,
    public style: StyleService,
    public status: StatusService,
    public condition: ConditionService,
    public collection: CollectionService,
    public processType: ProcessTypesService,
    public processStatus: ProcessStatusService,
    public processTransition: ProcessTransitionService,
    public destinationType: DestinationTypeService,
    public event: EventService,
    public customerAddress: CustomerAddressService,
    public track: TrackService,
    public role: RoleService,
    public file : FileService,
    public permission: PermissionService,
    public constant: ConstantService,
    public provider: ProviderService,
    public customerGroup: CustomerGroupService,
    public analytic: AnalyticService,
    public currency: CurrencyService,
    public courier: CourierService,
    public wishlist: WishlistService,
    public offers: OffersService,
    public general: GeneralService,
    public delivery: DeliveryService,
    public payment: PaymentService,
    public asyncProcess: AsyncProcessService,
    public checkout: CheckoutService,
    public elasticsearch: ElasticsearchService,
    public orderProduct: OrderProductService
  ) {}
}
